const $marquee = document.querySelector('[data-role=marquee]') as HTMLElement;
const $firstEl = $marquee.children[0] as HTMLElement;
const $cloneEl = $marquee.innerHTML;
const speed = 0.5;

function marquee() {
	let i = 0;

	$marquee.insertAdjacentHTML('beforeend', $cloneEl);
  
	setInterval(function () {
		$firstEl.style.marginLeft = `-${i}px`;

		if (i > 2 * $firstEl.clientWidth) {
			i = 0;
		}
		
		i = i + speed;
	}, 0);
}

marquee();